import { useEffect, useMemo, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/i18n";
import { useManual, Tour, pageFor } from "@/components/HelpPanel";

const L = { en: { welcome: "Welcome", intro: "This short tour shows exactly the screens your role uses.", next: "Next", done: "Done", skip: "Skip", of: "of", sidebar: "Your menu — only the modules your role can use are shown.", help: "The ? button opens the guide for the page you are on, with a video and a tour." },
  sq: { welcome: "Mirë se vini", intro: "Ky tur i shkurtër tregon pikërisht ekranet që përdor roli juaj.", next: "Tjetra", done: "Përfundo", skip: "Kalo", of: "nga", sidebar: "Menyja juaj — shfaqen vetëm modulet që roli juaj mund të përdorë.", help: "Butoni ? hap udhëzuesin për faqen ku jeni, me video dhe tur." },
  sr: { welcome: "Dobrodošli", intro: "Ova kratka tura pokazuje upravo ekrane koje vaša uloga koristi.", next: "Dalje", done: "Završi", skip: "Preskoči", of: "od", sidebar: "Vaš meni — prikazani su samo moduli koje vaša uloga može da koristi.", help: "Dugme ? otvara vodič za stranicu na kojoj ste, sa videom i turom." } };

export function roleTourSteps(navItems, pages, s) {
  const steps = [{ sel: "[data-testid='tenant-sidebar']", text: s.sidebar }];
  navItems.slice(0, 7).forEach((n) => { const pg = pageFor(pages, n.to); steps.push({ sel: `[data-testid='${n.id}']`, text: pg ? `${pg.title}: ${pg.intro}` : n.to }); });
  steps.push({ sel: "[data-testid='help-btn']", text: s.help });
  return steps;
}

export function RoleTour({ navItems, force, onDone }) {
  const { me } = useAuth();
  const { lang } = useT(); const s = L[lang] || L.en;
  const pages = useManual();
  const key = me?.user?.id ? `orbis_role_tour_${me.user.id}` : null;
  const [open, setOpen] = useState(false);
  useEffect(() => { if (key && Object.keys(pages).length && (force || !localStorage.getItem(key))) setOpen(true); }, [key, pages, force]);
  const steps = useMemo(() => roleTourSteps(navItems.filter((n) => n.to && !n.section && !n.group && n.to.startsWith("/app")), pages, s), [navItems, pages, s]);
  if (!open) return null;
  const close = () => { if (key) localStorage.setItem(key, new Date().toISOString()); setOpen(false); onDone?.(); };
  return <Tour steps={steps} labels={s} onClose={close} />;
}
